import dynamicData from "@/mixins/api_data/dynamic-data-mixin";

const defaultGetData = response => response.data.data.rightDtos;

export default function (name, fixtureIdentifier, path, getData = defaultGetData ) {
  return {
    mixins: [
      dynamicData('rights', path, getData)
    ],
    computed:{
      [name]: {
        get(){
          let index = this.rights?.findIndex(right => right.fixtureIdentifier === fixtureIdentifier);
          if (index >= 0) return this.rights[index].hasRight
          return false
        }
      }
    }
  }
}
